import { useUI } from "@/store/ui";
import { useUsers } from "@/store/users";
import { useNodes } from "./store/nodes";
import { API_WS_URL } from "./constants";

const stores: any = {
    user: useUsers,
    node: useNodes,
};

export default function () {
    let ws;

    const connect = function () {
        ws = new WebSocket(API_WS_URL, [localStorage.token]);

        ws.onopen = function () {
            console.log('ws open');
            useUI().wsOnline = true;
        };

        ws.onmessage = function (event) {
            const message = JSON.parse(event.data);

            if (stores[message.entity]) {
                const store = stores[message.entity]();
                if (store[message.action]) {
                    store[message.action](message.data);
                }
            }

        };

        ws.onerror = function (error) {
            console.log("WebSocket Error: ", error);
        };

        ws.onclose = function () {
            console.log('ws close');
            useUI().wsOnline = false;
            setTimeout(() => {
                console.log("Trying to reconnect...");
                connect();
            }, 5000);
        };
    };

    connect();

    return ws;
}
